export default __webpack_public_path__ + "static/media/header-bg.40869b13.png";